<template>
    <form id="mainForm" action="#" method="post">
      <Card>
        <template #title>
          <Toolbar>
            <template #left>
              <div class="p-card-title">Work Report</div>
            </template>
          </Toolbar>
        </template>
        <template #content>
          <div class="p-inputtext-sm p-fluid">
            <div class="grid">
              <div class="col-12 field grid" style="padding: 0 0.5rem 0 0.5rem">
                <label class="col-2">{{ $t("doc_date") }}</label>
                <DatePicker
                  dateFormat="dd/mm/yy"
                  v-model="header.Date_From"
                  class="col-4"
                />
                <label class="col-1">To</label>
                <DatePicker
                  dateFormat="dd/mm/yy"
                  v-model="header.Date_To"
                  class="col-4"
                />
              </div>
              <div class="col-12 field grid" style="padding: 0 0.5rem 0 0.5rem">
                <label class="col-2">{{ $t("created_date") }}</label>
                <DatePicker
                  dateFormat="dd/mm/yy"
                  v-model="header.Created_Date"
                  class="col-4"
                />
                <label class="col-1">To</label>
                <DatePicker
                  dateFormat="dd/mm/yy"
                  v-model="header.Created_Date_To"
                  class="col-4"
                />
              </div>
              <div class="col-12">
                <FormField
                  fieldName="Status"
                  :labelName="$t('status')"
                  v-model="header"
                  fieldClass="col-6"
                  labelClass="col-2"
                >
                  <CustomSelect
                    v-model="header.Status"
                    class="p-inputtext-sm"
                    :url="this.$API_URL + 'list/lookup'"
                    :minLength="0"
                    :params="{ group: 'WORK_STATUS' }"
                    :filter="true"
                  />
                </FormField>
               
              </div>
            </div>
          </div>
          <Button type="button" label="Generate" @click="getReport()" />
          &nbsp;
          <Button
            type="button"
            class="p-button-success"
            label="Reopen"
            @click="reopenTab()"
            v-show="this.reportTbl"
          />
        </template>
      </Card>
    </form>
  
    <ShowReport
      :title="title"
      :isVisible="showReport"
      :reportTbl="this.reportTbl"
      @close="resetBtn()"
    />
  </template>
  
  <script type="text/javascript">
  import ShowReport from "../Report/ShowReport.vue";
  import FormField from "../Base/Helper/FormField.vue";
  export default {
    components: {
      ShowReport,
      FormField,
    },
    data() {
      name: "PermitReport";
      return {
        test: 0,
        mode: "",
        url: this.$API_URL + "report/",
        companyCodeUser: this.$store.getters.getCompanyCode,
        companyIdUser: this.$store.getters.getCompanyId,
        idUser: this.$store.getters.getUserId,
        userName: this.$store.getters.getUsername,
        reportTbl: null,
        showReport: false,
        loadingReport: false,
        mergedOptions: [
          { label: "Y", value: 1 },
          { label: "N", value: 0 },
        ],
        header: {
          Work_Date_From: null,
          Work_Date_To: null,
          Created_Date: null,
          Created_Date_To: null,
          Type: null,
          Status: null,
          Executor: null,
          Company: null,
          Department: null,
        },
      };
    },
    methods: {
      reopenTab() {
        this.showReport = true;
      },
      resetBtn() {
        this.showReport = false;
      },
      tableToExcel() {
        this.loadingReport = !this.loadingReport;
      },
      getReport() {
        // this.visibleBar = true;
        // this.loadingReport = !this.loadingReport;
        this.$emit("blockBody");
        this.$axios
          .post(this.url + "work", this.header)
          .then((response) => {
            this.reportTbl = {
              header: response.data.data.header,
              content: response.data.data.content,
              title: response.data.data.title,
            };
            // this.showError(response);
            this.showReport = true;
            this.$emit("unblockBody");
          })
          .catch((exc) => {
            // this.showError(response);
            // //console.log(1);
            this.$emit("unblockBody");
          });
      },
      showError(msg) {
        this.loadingReport = !this.loadingReport;
      },
      closeReport() {
        this.showReport=false;
      },
    },
    mounted() {},
  };
  </script>
  